import PaginationStore from './PaginationStore'

export default PaginationStore
